import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TradingGroupImpl } from "../model/impl/TradingGroupImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TradingGroupImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TradingGroupImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.branchCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(1),
        false,
        encodable.branchCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.groupId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(2),
        false,
        encodable.groupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.groupCode != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(3),
        false,
        encodable.groupCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.typeId != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(4),
        false,
        encodable.typeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.typeDisplayName != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(5),
        false,
        encodable.typeDisplayName,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.isAutoFilledFg != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(6),
        false,
        encodable.isAutoFilledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.isExternallyFilledFg != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(7),
        false,
        encodable.isExternallyFilledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.isInternallyArbitratedFg != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(8),
        false,
        encodable.isInternallyArbitratedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.isBenchmarkFg != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(9),
        false,
        encodable.isBenchmarkFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.isStagingFg != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(10),
        false,
        encodable.isStagingFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.pauseResumeFg != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(11),
        false,
        encodable.pauseResumeFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.acceptsPausedOrdersFg != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(12),
        false,
        encodable.acceptsPausedOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.roundToMillionsType != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(13),
        false,
        encodable.roundToMillionsType,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.isSupportsBMAlgosFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(14),
        false,
        encodable.isSupportsBMAlgosFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.isProcessesFillUpdatesAfterCancellationEnabled != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(15),
        false,
        encodable.isProcessesFillUpdatesAfterCancellationEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.gtcAsDayOrderConfGroup != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(16),
        false,
        encodable.gtcAsDayOrderConfGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.orderCancelReplaceFg != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(17),
        false,
        encodable.orderCancelReplaceFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.fillNowFg != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(18),
        false,
        encodable.fillNowFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.supportsInvertsFg != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(19),
        false,
        encodable.supportsInvertsFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingGroupImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TradingGroupImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.Long"],
    [3, "java.lang.String"],
    [4, "java.lang.Long"],
    [5, "java.lang.String"],
    [6, "java.lang.Boolean"],
    [7, "java.lang.Boolean"],
    [8, "java.lang.Boolean"],
    [9, "java.lang.Boolean"],
    [10, "java.lang.Boolean"],
    [11, "java.lang.Boolean"],
    [12, "java.lang.Boolean"],
    [13, "com.bcdfx.model.RoundToMillionsType"],
    [14, "java.lang.Boolean"],
    [15, "java.lang.Boolean"],
    [16, "java.lang.Boolean"],
    [17, "java.lang.Boolean"],
    [18, "java.lang.Boolean"],
    [19, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TradingGroupImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.branchCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.groupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.groupCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.typeId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.typeDisplayName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.isAutoFilledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.isExternallyFilledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.isInternallyArbitratedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.isBenchmarkFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.isStagingFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.pauseResumeFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.acceptsPausedOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.RoundToMillionsType = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.roundToMillionsType = <CubiqTS.RoundToMillionsType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.isSupportsBMAlgosFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.isProcessesFillUpdatesAfterCancellationEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.gtcAsDayOrderConfGroup = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.orderCancelReplaceFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.fillNowFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.supportsInvertsFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingGroupImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TradingGroupImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TradingGroupImplEncoder.fidTypeMap.has(fid);
  }
}
